"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const decorators_js_1 = require("lit/decorators.js");
const lit_1 = require("lit");
const lit_html_1 = require("lit-html");
const control_1 = require("./control");
/**
 * Чекбокс
 */
let CheckboxField = class CheckboxField extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        /**
         * Имя поля
         */
        this.name = '';
        /**
         * Надпись
         */
        this.label = '';
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Обрабатывает изменения элемента
     */
    onChange(e) {
        var _a;
        (_a = this.control) === null || _a === void 0 ? void 0 : _a.setValue(e.target.checked);
    }
    /**
     * Возвращает представление
     */
    render() {
        var _a;
        return (0, lit_html_1.html) `
            <label class="art-checkbox">
                <input 
                    type="checkbox" value="" 
                    name="${this.name}" 
                    .checked="${(_a = this.control) === null || _a === void 0 ? void 0 : _a.getValue()}" 
                    @change="${this.onChange}">
                <span class="art-checkbox__check">
                    <svg class="check-icon" fill="none" height="12" viewBox="0 0 15 12" width="15" xmlns="http://www.w3.org/2000/svg"><path d="m13.5 2-8.5 8.5-3-3" stroke-linecap="square" stroke-width="2"/></svg>
                </span>
                <span class="text">${this.label}</span>
            </label>
        `;
    }
};
__decorate([
    (0, decorators_js_1.property)({ type: String }),
    __metadata("design:type", String)
], CheckboxField.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String }),
    __metadata("design:type", String)
], CheckboxField.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: control_1.Control }),
    __metadata("design:type", control_1.Control)
], CheckboxField.prototype, "control", void 0);
CheckboxField = __decorate([
    (0, decorators_js_1.customElement)('art-checkbox-field')
], CheckboxField);
